import { render, staticRenderFns } from "./settings-select.vue?vue&type=template&id=3bdadfb4&scoped=true&"
import script from "./settings-select.vue?vue&type=script&lang=js&"
export * from "./settings-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdadfb4",
  null
  
)

export default component.exports